import { Component, Input } from '@angular/core';
import {
  ControlContainer,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';

@Component({
    selector: 'pr-input-icon-multiselect',
    templateUrl: './pr-input-icon-multiselect.component.html',
    styleUrls: ['./pr-input-icon-multiselect.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: PrInputIconMultiselectComponent,
        },
    ],
    standalone: false
})
export class PrInputIconMultiselectComponent implements ControlValueAccessor {
  @Input() formControlName: string;
  @Input() derrors: boolean = false;
  @Input() label: string;
  @Input() options: any[];

  values: string[] = [];
  touched = false;
  disabled = false;
  onChange = values => {};
  onTouched = () => {};

  constructor(private controlContainer: ControlContainer) {}

  get control() {
    return this.controlContainer.control.get(this.formControlName);
  }

  ngOnInit() {}

  clean() {
    let values = [];
    this.values.map(v => {
      if (this.options.find(o => o.value === v)) values.push(v);
    });
    this.values = values;
  }

  onInputChange($event) {
    let value: string = $event.target.value;
    let checked: boolean = $event.target.checked;
    if (checked) this.values.push(value);
    else {
      var index = this.values.indexOf(value);
      if (index !== -1) {
        this.values.splice(index, 1);
      }
    }
    this.clean();
    this.onChange(this.values);
  }

  checked(value: string) {
    return this.values.includes(value);
  }

  writeValue(values: string[]): void {
    this.values = values;
  }

  registerOnChange(onChange: any): void {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
